import { ON_START_GAME } from '../state-constants/stateConstants';

export const onStartGame = (bool) => ({
  type: ON_START_GAME,
  payload: bool,
});



// WEBPACK FOOTER //
// ./src/state-actions/onStartGame.js